require("./qf/predictiveSearch");
require("./qf/LocalizationForm");
require("./qf/v3-accordion");

import { CartQf } from './qf/cart';
import { GlobalListeners } from './qf/global_listeners';
import { WishlistObjectQf } from './qf/wishlistAsObject';
import { ModalController } from './qf/ModalController';
import { LoadMore } from './qf/loadMore';
import { QfForm } from './qf/formSubmission';
import { PriceMatchPromise } from './gb/PriceMatchPromise';
// import { ProductFormVariantSelect } from './qf/productFormVariantSelect';
import { GBVariantSelect } from './gb/GBVariantSelect';
import { ProductForm } from './qf/qf-ProductForm';


window.cart = new CartQf();
window.globalListeners = new GlobalListeners();
window.wishlist = new WishlistObjectQf();
window.modalController = new ModalController()
window.LoadMore = LoadMore;
window.QfForm = QfForm;
window.PriceMatchPromise = new PriceMatchPromise;
// window.ProductFormVariantSelect = ProductFormVariantSelect;
window.ProductFormVariantSelect = GBVariantSelect;
window.ProductForm = ProductForm;
